module.exports = "https://r.zoocdn.com/_next/static/images/shared-ownership-926a1c86cb1c0ff46cae46a99e6ccbc6.png";